import { render, staticRenderFns } from "./ChartCrece.vue?vue&type=template&id=10e8f75a&"
import script from "./ChartCrece.vue?vue&type=script&lang=js&"
export * from "./ChartCrece.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports